import baseUrl from '../../../utils/baseUrl';
import getToken from '../../../utils/getToken';

// interface AddFootprintRequest {
//   footprintableType: string;
//   footprintableId: string;
//   userProfileId?: string;
//   artistId?: string;
//   memberIds?: string[];
//   actionType?: string;
//   linkUrl?: string;
//   description?: string;
//   dataUrls?: string[];
// }

interface AddEventRequest {
  artistId?: string;
  memberIds?: string[];
  location: {
    name: string;
    kakaoUid: string;
    siteType: string;
  };
  event: {
    startDate: string;
    endDate: string;
    name: string;
    organizerTweetId: string;
    description: string;
    posterDataUrls: string[];
    linkUrl?: string;
  };
}

// export default async function AddFootprint(request: AddFootprintRequest) {
//   return fetch(`${baseUrl()}/api/v1/footprints/`, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       Authorization: `Bearer ${getToken()}`
//     },
//     body: JSON.stringify({
//       footprint: {
//         footprintable_type: request.footprintableType,
//         footprintable_id: request.footprintableId,
//         artist_id: request.artistId,
//         member_ids: request.memberIds,
//         user_profile_id: request.userProfileId,
//         description: request.description,
//         action_type: request.actionType,
//         link_url: request.linkUrl,
//         data_urls: request.dataUrls
//       }
//     })
//   });
// }

export default async function AddReportEvent(request: AddEventRequest) {
  return fetch(`${baseUrl()}/api/v1/locations`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({
      artist_id: request.artistId,
      member_ids: request.memberIds,
      location: {
        name: request.location.name,
        kakao_uid: request.location.kakaoUid,
        site_type: request.location.siteType
      },
      event: {
        start_date: request.event.startDate,
        end_date: request.event.endDate,
        name: request.event.name,
        organizer_tweet_id: request.event.organizerTweetId,
        poster_data_urls: request.event.posterDataUrls,
        description: request.event.description,
        link_url: request.event.linkUrl
      }
    })
  });
}
